export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind, Message} from 'kpc';
import type {Sender, SenderAttachment, MessageSendPayload} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
    generating?: boolean
    focused?: boolean
}

export default class extends Component<Props> {
    static template = template;

    private senderRef: Sender | null = null;

    static defaults() {
        return {
            value: '帮我整理一下这份附件内容',
            attachments: [
                {key: 'a', uid: 'a', name: 'brief.pdf', byte: 128 * 1024, status: 'done' as const},
            ] as SenderAttachment[],
            generating: false,
            focused: false,
        };
    }

    isSubmitDisabled() {
        if (this.get('generating')) return true;
        const value = (this.get('value') || '').trim();
        const attachments = this.get('attachments') || [];
        return !value && attachments.length === 0;
    }

    isClearDisabled() {
        const value = (this.get('value') || '').trim();
        const attachments = this.get('attachments') || [];
        return !value && attachments.length === 0;
    }

    @bind
    onFocus() {
        this.set('focused', true);
    }

    @bind
    onBlur() {
        this.set('focused', false);
    }

    @bind
    onMessageSend(payload: MessageSendPayload) {
        this.set('generating', true);
        Message.success(`调用 submit() 成功，发送内容：${payload.value || '附件消息'}`);
    }

    @bind
    onStopGenerate() {
        this.set('generating', false);
        Message.warning('已触发 stopGenerate()');
    }

    @bind
    handleFocus() {
        this.senderRef?.focus();
        Message.info('已调用 focus()');
    }

    @bind
    handleBlur() {
        this.senderRef?.blur();
        Message.info('已调用 blur()');
    }

    @bind
    handleSubmit() {
        this.senderRef?.submit();
    }

    @bind
    handleClear() {
        this.senderRef?.clear();
        Message.info('已调用 clear()');
    }

    @bind
    handleStopGenerate() {
        this.senderRef?.stopGenerate();
    }
}